import React, { useState } from 'react';
import { getFunctions, httpsCallable } from 'firebase/functions';
import AdminSidebar from '../../components/AdminSidebar';
import AdminHeader from '../../components/AdminHeader';
import './ToolsPage.css'; // استيراد ملف CSS المنفصل

const ToolsPage = () => {
  const [loading, setLoading] = useState(false);
  const [result, setResult] = useState(null);
  const [error, setError] = useState(null);
  
  const standardizeOrderStatuses = async () => {
    setLoading(true);
    setResult(null);
    setError(null);
    
    try {
      const functions = getFunctions();
      const standardizeFunction = httpsCallable(functions, 'standardizeOrderStatuses');
      
      // إضافة معالجة أفضل للاستجابة
      console.log('جاري تنفيذ وظيفة توحيد حالات الطلبات...');
      const response = await standardizeFunction();
      
      // التحقق من وجود بيانات في الاستجابة
      if (response && response.data) {
        console.log('نتيجة توحيد حالات الطلبات:', response.data);
        setResult(response.data);
      } else {
        console.warn('تم استلام استجابة فارغة من الخادم');
        setResult({
          success: true,
          message: "تم تنفيذ العملية ولكن لم يتم استلام تفاصيل",
          count: 0,
        });
      }
    } catch (err) {
      console.error('خطأ في استدعاء الوظيفة:', err);
      // عرض رسالة خطأ أكثر تفصيلاً
      const errorMessage = err.message || 'حدث خطأ غير معروف';
      setError({
        message: errorMessage,
        code: err.code || 'unknown',
        details: err.details || null,
      });
    } finally {
      setLoading(false);
    }
  };
  
  return (
    <div className="restaurant-dashboard">
      <AdminSidebar />
      <div className="restaurant-dashboard-content">
        <AdminHeader adminName="أدوات النظام" />
        
        <div className="restaurant-dashboard-welcome">
          <h1>أدوات النظام</h1>
          <p>أدوات مساعدة للإدارة والصيانة</p>
        </div>
        
        <div className="admin-tools-section">
          <div className="tool-card">
            <h3>توحيد حالات الطلبات</h3>
            <p>تستخدم هذه الأداة لتوحيد حالات الطلبات في قاعدة البيانات وتصحيح أي تناقضات في الحالات.</p>
            <button 
              className="action-button" 
              onClick={standardizeOrderStatuses}
              disabled={loading}
            >
              {loading ? 'جاري التنفيذ...' : 'توحيد حالات الطلبات'}
            </button>
            
            {result && (
              <div className="result-box success">
                <h4>تم التنفيذ بنجاح!</h4>
                <p>{result.message}</p>
                {result.count !== undefined && (
                  <p>تم تحديث {result.count} طلب.</p>
                )}
              </div>
            )}
            
            {error && (
              <div className="result-box error">
                <h4>حدث خطأ أثناء التنفيذ</h4>
                <p>{error.message}</p>
                {error.code && error.code !== 'unknown' && (
                  <p>رمز الخطأ: {error.code}</p>
                )}
                {error.details && (
                  <p>تفاصيل إضافية: {JSON.stringify(error.details)}</p>
                )}
              </div>
            )}
          </div>
          
          {/* يمكن إضافة أدوات أخرى هنا */}
        </div>
      </div>
    </div>
  );
};

export default ToolsPage; 